import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const Terms = () => {
    const dispatch = useDispatch(); 
    const cancelHandler = () => dispatch(resetModel());

    const confirmation = () => {
        cancelHandler();
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } className='terms-model' centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    <h4 className="page-title">納智捷汽車股份有限公司</h4>
                    <h4 className="page-title">「到府取送車服務」約定事項</h4>
                    <div style={{ textAlign: 'right', marginTop: '2rem'}}>公告日期：2023年 10 月 12 日</div>
                    <div style={{ textAlign: 'right'}}>文件版本：20231012-v.1</div>
                    <div style={{ marginTop: '1rem'}}><span>歡迎使用納智捷汽車股份有限公司提供之「到府取送車服務」，請您(以下稱您或客戶)於申請使用本服務前，詳閱以下約定事項：</span></div>
                    <div className="terms" style={{ marginTop: '1rem'}}>
                        <div className="terms-container">
                            <div className="terms-title">第一條：服務說明：</div>
                            <div className="terms-content">
                                <ol>
                                    <li>本約定事項為納智捷汽車股份有限公司(以下稱納智捷汽車)提供「到府取送車服務」(以下稱本服務)之約定內容。客戶提交本服務預約表單即表示已閱讀並同意本約定事項，且亦同意以納智捷汽車所設定之收費標準支付服務費用。</li>
                                    <li>您須年滿十八歲(含)以上，始能下載及啟用納智捷汽車APP並登錄註冊，每人限註冊一個會員帳號，不可重複註冊登錄，當您註冊會員時，需提供您本人正確、最新及完整資料，且不得以第三人之名義註冊為會員，並以會員個人手機號碼為唯一綁定之認證資格完成註冊手續。</li>
                                    <li>本服務僅限下載並註冊納智捷汽車APP之客戶申請。</li>
                                    <li>當您的個人資料有任何異動時應即時更新，確保其為正確、最新及完整資料，以獲得最佳之服務。</li>
                                    <li>若您提供任何錯誤、不實或不完整資料，或原提供的資料已不符合真實，納智捷汽車有權暫停或終止您的會員帳號，並暫停或終止您使用本服務之全部或一部分，如因前開情形導致您的權益受損，請您自行承擔。</li>
                                    <li>納智捷汽車對您所提供的個人資料不負查證真偽之責任，若因您登錄不實資料或冒用他人名義以致侵害他人權利或違法時，應自負相關法律責任；若因此造成納智捷汽車損害，您須負賠償責任。</li>
                                    <li>如您未成年，除非取得您的監護人同意，您應該立即停止使用本服務。當您開始使用本服務，即視為您／您的監護人已經同意納智捷汽車按本約定事項提供服務，並蒐集、處理、利用、保護您的個人資料。</li>
                                    <li>本服務須依實際人力配置安排，納智捷汽車將盡全力滿足客戶需求，同時保留拒絕提供服務的權利。</li>
                                </ol>
                            </div>
                        </div>
                        <div className="terms-container">
                            <div className="terms-title">第二條：駕駛資格：</div>
                            <div className="terms-content">
                                <ol>
                                    <li>納智捷汽車所指派之職業代駕人員均具備職業駕駛執照及警察刑事紀錄證明書之全部期間無犯罪紀錄證明，惟若因人力配置考量，由經銷商人員執行取送車服務時不在此限。</li>
                                    <li>客戶應依據納智捷汽車提供之代駕人員資訊，於交付車輛前核對代駕人員識別證或經銷商員工名片；如因未經身份核對，即將車輛交付予非納智捷汽車之代駕人員或員工代為駕駛，因而所生之糾紛或損害，概由客戶自行負責，納智捷汽車不承擔任何責任。</li>
                                </ol>
                            </div>
                        </div>
                        <div className="terms-container">
                            <div className="terms-title">第三條：預約、修改與取消：</div>
                            <div className="terms-content">
                                <ol>
                                    <li>預約方式 : 本服務為預約制，需下載並註冊指定之納智捷汽車APP方可預約，可預約服務日期為自當日起算3日後之10個工作日，預約服務時段以系統顯示為準。前述工作日和服務時段以納智捷服務中心工作日和營業時間為準，服務起迄點皆需為納智捷汽車服務區域。納智捷保留審核預約單，並決定是否同意接受預約之最終權利。</li>
                                    <li>急單預約：客戶如欲預約「預定服務日期為自預約當下起算24小內」者，屬「急單」狀況，請直接與納智捷汽車客服聯繫(客服專線：0800-588-088 )，納智捷汽車將依代駕人員調度狀況決定是否接受預約並派案，不保證必能提供服務。急單預約將依本約定事項第四條約定收取費用。</li>
                                    <li>修改方式 : 預約單一經送出即無法修改。如需調整，客戶需自行取消原預約單，並依需求重新提交新預約單。</li>
                                    <li>取消方式 : 各筆預約單最晚可在預約服務執行當日(不含)前2天晚間23:59前透過納智捷汽車APP查詢取消。欲於預約執行時間前48小時內取消者，須與納智捷汽車客服聯繫(客服專線：0800-588-088)。因取消服務應酌收之相關費用，依本約定事項第四條規定辦理。</li>
                                    <li>未經由納智捷汽車APP進行預約，或客戶自行與代駕人員預約提供服務者，其所生之權利義務概與納智捷汽車無關，客戶與代駕人員皆不享有納智捷汽車所提供之補償、保險等額外之服務。</li>
                                    <li>客戶可透過納智捷汽車APP為第三人提出預約本服務之需求(即預約使用本服務之車輛經納智捷汽車系統判定，非屬客戶於APP系統註冊登載之車輛)，惟客戶應自行注意是否取得第三人授權同意，如由客戶註冊帳戶所提出或提供之任何服務請求，導致第三人財產遭受損害或發生任何爭議，概由客戶自行承擔負責，與納智捷汽車無關。如納智捷汽車接獲第三人提出賠償要求(包括但不限於服務費用、車輛損害等)，且該要求經我們酌情決定審核，除該第三人自行向客戶主張相關權利外，納智捷汽車亦將據此依法向客戶請求損害賠償等權利。</li>
                                    <li>客戶於預約單指定之取車及離廠時間僅供參考，實際時間依納智捷汽車服務中心通知為準。</li>
                                </ol>
                            </div>
                        </div>
                        <div className="terms-container">
                            <div className="terms-title">第四條：收費標準：</div>
                            <div className="terms-content">
                                <ol>
                                    <li>里程費：自服務始點起算10公里(含)內為新台幣(下同)500元整(以下稱基本里程費)，超過10公里，每公里加收55元，未滿1公里以1公里計費，以納智捷汽車APP系統計算之里程數據為費用計算基礎。</li>
                                    <li>
                                        <span>代駕待時費 :</span>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{ width: '1rem'}}>i.</div>
                                            <div style={{ flex: '1'}}>
                                                <span>代駕人員抵達指定服務地點時，若發生延後取、還車時間狀況，納智捷汽車將收取待時費。待時起算時點自原預約時間起算，未滿10分鐘不收費，滿10分鐘(含)加收55元，之後每2分鐘加收10元，最長等待時間為30分鐘(含)，並以155元為待時費收費上限。</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{ width: '1rem'}}>ii.</div>
                                            <div style={{ flex: '1'}}>
                                                <span>代駕人員抵達指定服務地點並等待30分鐘(含)後即離開現場，當筆預約服務費用將僅收取空趟費，無待時費之適用。空趟費計算標準，依本合約第四條第4項規定辦理。</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>客戶待時費 : 代駕人員若未於客戶預約時間到達指定服務地點，自原預約時間起算10分鐘(含)內無須補償客戶任何權益，若滿10分鐘至30分鐘，則本次預約單服務費總額將自動抵扣100元以為補償，客戶若等候時間超過30分鐘(含)，則除當次服務不收費外，亦提供客戶次筆預約單扣抵基本里程費500元整之一次性全額補償。前述基本里程費補償，於本服務系統結算服務費用總額時自動一次性全額扣抵，客戶除不得要求分次扣抵、展延、移轉、贈與予其他客戶帳戶外，亦不得要求折換現金或其他等價替代物。</li>
                                    <li>
                                        <span>空趟費 :</span>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{ width: '1rem'}}>i.</div>
                                            <div style={{ flex: '1'}}>
                                                <span>取車：代駕人員抵達後指定服務地點並等待30分鐘(含)後離開現場，該次服務費將收取空趟費；空趟費以該次服務里程費總額70%計收。</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex'}}>
                                            <div style={{ width: '1rem'}}>ii.</div>
                                            <div style={{ flex: '1'}}>
                                                <span>還車：代駕人員抵達指定還車地點並等待30分鐘(含)後，客戶未出現辦理現場還車作業，代駕人員即將車輛開回原服務中心。本次空趟費以該次服務里程費總額170%計收。</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>調度費 :如預約隔日之取還車服務，屬「急單」狀況，除里程費外，納智捷汽車將額外收取調度費160元整。</li>
                                    <li>
                                        <span>取消服務手續費: 客戶如取消已預約服務，服務費用依以下標準計算：</span>
                                        <div className='table-container'>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '2rem' }}></th>
                                                        <th>取消時點</th>
                                                        <th>取消方式</th>
                                                        <th>計費標準</th>
                                                    </tr>
                                                    <tr>
                                                        <td>1.</td>
                                                        <td>預訂服務日前2個日曆天取消</td>
                                                        <td>線上取消(管道：納智捷APP 、 LINE OA 、和官網)</td>
                                                        <td>不收費</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2.</td>
                                                        <td>預定服務日48小時(含)取消</td>
                                                        <td>需與納智捷汽車客服聯繫(客服專線：0800-588-088)</td>
                                                        <td>里程費總額70%</td>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </li>
                                    <li>
                                        <span>代駕服務期間所產生之費用如:過路費、停車費、油資…等，應由車主自行負擔，計費方式如下：</span>
                                        <div className='table-container'>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '2rem' }}></th>
                                                        <th style={{ width: '6rem' }}>項目費用</th>
                                                        <th>執行與計費方式</th>
                                                    </tr>
                                                    <tr>
                                                        <td>1.</td>
                                                        <td>過路費</td>
                                                        <td>依國道電子計程收費方式由車主自行付費</td>
                                                    </tr>
                                                    <tr>
                                                        <td>2.</td>
                                                        <td>停車費</td>
                                                        <td>車輛離開停車場前由車主負責付清</td>
                                                    </tr>
                                                    <tr>
                                                        <td>3.</td>
                                                        <td>油資</td>
                                                        <td>
                                                            <div>
                                                                <div style={{ display: 'flex'}}>
                                                                    <div style={{ width: '1rem'}}>1.</div>
                                                                    <div style={{ flex: '1'}}>
                                                                        <span>因(1)剩餘油量過低無法執行代駕服務，或(2)受客戶委託時，代駕人員可代客戶加油，惟代駕人員保留決定是否接受委託之權利。</span>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex'}}>
                                                                    <div style={{ width: '1rem'}}>2.</div>
                                                                    <div style={{ flex: '1'}}>
                                                                        <span>油資將由代駕人員取車時與客戶確認金額並收取現金，加油發票將於還車時交付客戶。</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>4.</td>
                                                        <td>其他</td>
                                                        <td>依與客戶協商方式付費</td>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </li>
                                    <li>客戶如透過線上刷卡支付本服務費用，須另行接受並遵守第三方付款處理商及信用卡發卡機構的條款、條件及隱私權政策等規定。若前開相關機構發生任何錯誤(包括但不限於帳務系統作業遲滯等)或作業爭議等，納智捷汽車概不負責。</li>
                                    <li>本服務費用以納智捷汽車公布之最新收費標準為準。如有調整更新，將於納智捷汽車APP服務專頁、網站、其他車主服務專業等處公告，不另行個別通知。</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第五條：客戶義務與責任：</div>
                        <div className="terms-content">
                            <ol>
                                <li>客戶需確認本次所用車輛具備三個必要條件：車輛手續齊全、車況正常可正常行駛（非改裝車及部件）、有車輛保險（須包含強制汽車責任保險）：如以上條件不具備，請客戶如實告知代駕人員，代駕人員有權拒絕提供本次服務。如因客戶未主動告知或隱瞞以上狀況帶來的糾紛或者損害，納智捷汽車不承擔任何責任，概由客戶自行負責。</li>
                                <li>根據「道路交通管理處罰條例」第14條規定，「汽車行駛應隨車攜帶行車執照」，若因行照未隨車而產生一切責任均由車主負擔。</li>
                                <li>客戶在移交車輛時，須檢查車上的貴重物品並妥善保管，代駕人員保證不碰觸除了駕駛必須接觸之外的任何物品。如發生物品丟失情況，請即時提出，代駕人員會即時告知回報納智捷汽車並報警，客戶及代駕人員須配合員警進行調查。當次服務結束，經客戶同意代駕人員離開後，即推定客戶已確認本次服務過程中沒有發生物品丟失情況。</li>
                                <li>與代駕人員辦理車輛取車和還車作業(以下稱代駕作業)之當事人應為委託客戶本人，代駕人員保留於代駕作業現場查驗客戶身分，並決定是否續行提供服務之權利。客戶如欲委託他人辦理代駕作業，應於預約服務日前通知納智捷汽車並於預約單備註，或使受委託人得向代駕人員出示相關證明(包括但不限於授權書等)其已取得客戶授權執行本作業之證明文件；因委託他人辦理代駕作業所生之爭議(包括但不限於無權代理、車輛毀損、失竊等)，概由客戶自負全責，與納智捷汽車無關，且納智捷亦不負任何賠償和違約責任。</li>
                                <li>代駕車輛若非委託客戶(即預約人)所有，經納智捷公司完成服務，並將汽車鑰匙歸還該預約人確認後，事後如原車主發現車輛異狀情形，概由原預約人全權負責，與納智捷汽車無關。</li>
                                <li>客戶須向納智捷汽車提供真實合法的有效資訊，如因提供的資訊虛假、錯誤、不準確、不完整，所導致的服務及資訊偏差、失誤，納智捷汽車不承擔任何責任；由此引起的任何損失由客戶自行承擔。</li>
                                <li>因取、還車服務執行當下需上傳車況照片及相關資料到納智捷汽車系統存查，代駕人員可能需與取、還車聯絡人會面處具備網路訊號穩定要件，始能續行取送車服務。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第六條：代駕人員義務與責任：</div>
                        <div className="terms-content">
                            <ol>
                                <li>代駕人員如遇路阻、交通事故、交通管制，或颱風等其他不可抗力因素無法於約定時間內抵達約定地點時，納智捷汽車或代駕人員將即時通知乘客變更抵達時間，或派遣其他代駕人員前往，或經雙方溝通後取消該次服務；該次服務費用之計算，由納智捷汽車人員與客戶依個案實際事發狀況共同商議。</li>
                                <li>服務途中，代駕人員不得違規行駛，如果不慎違規行駛，違規罰款由代駕人員自行承擔；客戶無權要求代駕人員走特定路線，如果乘客提出違規要求，代駕人員有權拒絕（如因委託方干擾安全駕駛造成違規及交通事故，代駕人員不承擔相應責任與賠償義務，由客戶自行承擔)。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第七條：賠償：</div>
                        <div className="terms-content">
                            <ol>
                                <li>
                                    <span>納智捷汽車及代駕人員不承擔以下相應責任及賠償義務：</span>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>i.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>納智捷品牌車輛 : 代駕過程中因爆胎、機件老化、天災等不可抗力之因素、因意外導致外界掉落異物對車輛損傷、輪胎紮釘及壓石子等。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>ii.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>非納智捷品牌車輛 : 除前款納智捷品牌車輛所載之不承擔項目外，若發生車輛自燃、方向盤及刹車失靈狀況，亦不屬應承擔及賠償義務範圍。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>iii.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>所有品牌車輛：非代駕人員操作造成的車輛故障及交通事故。</span>
                                        </div>
                                    </div>
                                </li>
                                <li>代駕人員執行服務中，如遇意外交通事故發生，經交通警察大隊判定事故主要責任應歸責於代駕人員時，由代駕責任險先行出險；若為經銷商人員執行代駕服務，而經銷商人員負有責任時，則由公共意外險出險。</li>
                                <li>車輛保險未能給付部份，將按交通事故肇事責任比例分攤，倘該交通事故非因代駕人員所肇責，則代駕人員及納智捷汽車均不負損害賠償責任，由乘客直接向相應責任方進行追償。</li>
                                <li>針對意外事故，納智捷汽車提供每日不超過新台幣500元，累計額度不超過新台幣5,000元之交通補償款，惟客戶應提供維修開銷單據或相關交易憑證予納智捷汽車確認，如未能提供，納智捷汽車有權拒絕給付。</li>
                                <li>除上述約定外，代駕人員及納智捷汽車不再對客戶的其他損失承擔責任。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第八條：資訊保護與服務提供：</div>
                        <div className="terms-content">
                            <ol>
                                <li>客戶應當妥善保管自己的納智捷汽車APP帳號，且不應在沒有取得當事人授權的情況下使用他人帳號。</li>
                                <li>客戶不得利用代駕人員資料騷擾、妨礙他人或從事任何違法或侵權行為。</li>
                                <li>鑒於網路服務特殊性，以及本服務所需之資訊來源係由客戶提供，納智捷汽車無法逐一審查資訊的真實性、準確性，故客戶應於操作本服務預約介面時自行審慎判斷並獨立做出決定。因使用本服務預約介面導致的損害，除納智捷汽車故意造成外，納智捷汽車不承擔任何責任。</li>
                                <li>納智捷汽車有權不經事先通知，隨時變更、中斷或終止部分或全部的服務，並且不保證本服務一定能滿足客戶要求。</li>
                                <li>客戶如未透過納智捷汽車APP預約本服務，除不能享受本約定事項中任何權利外，因此發生的爭議以及造成的損失，納智捷汽車亦不承擔任何責任。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第九條：個人資料保護：</div>
                        <div className="terms-content">
                            <ol>
                                <li>客戶同意在為執行並提供本服務之必要目的範圍內，納智捷汽車得蒐集、處理及利用其個人資料。</li>
                                <li>為執行並提供本服務目的範圍內，客戶同意納智捷汽車得將客戶預約時提供之個人資料提供給本服務委外執行廠商及其代駕人員。</li>
                                <li>為維護客戶權益並提供妥善服務，您同意納智捷汽車及其執行本服務之委外廠商得在處理和利用與您有關的交易糾紛或代駕服務爭議之必要目的範圍內，將您的個人資料提供予交易相對人或利害關係人。</li>
                                <li>本服務之「個人資料保護暨隱私權政策」，詳本約定事項附件。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第十條：法律適用與管轄：</div>
                        <div className="terms-content">
                            <ol>
                                <li>本約定事項之效力、解釋、變更、執行與爭議解決均適用中華民國法律，如無相關法律規定的，則應參照通用商業慣例和（或）行業慣例。</li>
                                <li>客戶與納智捷汽車間因使用本服務產生爭議，應先行充分友好協商處理；若協商不成，發生訴訟時，雙方同意以系爭個案預約單之服務中心所在地之管轄法院為第一審管轄，但不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之小額訴訟管轄法院之適用。</li>
                                <li>本約定事項任一條款被廢止或被視為無效，不影響本約定事項其餘條款效力。</li>
                                <li>本約定事項的最終解釋權歸納智捷汽車APP平台運營方-納智捷汽車所有。</li>
                            </ol>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第十一條：服務糾紛事件處理：</div>
                        <div className="terms-content">
                            <span>本服務消費者爭議和客戶申訴專線：0800-588-088。</span>
                        </div>
                    </div>
                    <div className="terms-container">
                        <div className="terms-title">第十二條：服務通知、變更和終止：</div>
                        <div className="terms-content">
                            <ol>
                                <li>所有通過納智捷汽車官網、納智捷汽車APP、行動通訊軟體(如：LINE)、簡訊、Email等方式發佈的本服務實施細則、公告、通知、產品或流程說明等，均視為本約定事項的不可分割的組成部分並具同等法律效力。</li>
                                <li>本約定事項一經公告發佈即生效。納智捷汽車可以通過官網、納智捷汽車APP、行動通訊軟體、簡訊等方式對本約定事項內容的發佈、修改、增加、廢止等作出公佈或通知，也可對本服務功能進行限制或終止使用，客戶應自行隨時關注納智捷汽車公告資訊，將不個別通知。本約定事項內容一經公佈或通知即取代原規定並發生效力，如客戶不同意發佈或變更的內容，應立即停止使用本服務；若繼續使用，則視為同意發佈或變更事項。</li>
                                <li>
                                    <span>於以下情況發生時，納智捷汽車有權限制或終止提供本服務： </span>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>i.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>客戶提供手機號碼不存在或無法接收資訊，且無其他方式得取得聯繫。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>ii.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>本約定事項變更時，客戶明示並通知納智捷汽車不願接受新變更內容。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>iii.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>客戶有違法或違約行為。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1rem'}}>iv.</div>
                                        <div style={{ flex: '1'}}>
                                            <span>其他為維護納智捷汽車運營秩序所採取之限制或終止服務措施。</span>
                                        </div>
                                    </div>
                                </li>
                                <li>納智捷汽車在限制或終止提供本服務後，將依相關法律規定繼續保存客戶之註冊及服務使用紀錄資訊，並就客戶於使用服務期間之違法或違約行為主張法律責任。</li>
                            </ol>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: '0.2rem', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginBottom: '1rem' }} />
                    <div><span>附件</span></div>
                    <h4 className="page-title">納智捷汽車股份有限公司</h4>
                    <h4 className="page-title">到府取送車服務-個人資料保護暨隱私權政策</h4>
                    <div style={{ textAlign: 'right', marginTop: '2rem'}}>公告日期：2023年 10 月 12 日</div>
                    <div style={{ textAlign: 'right'}}>文件版本：20230926-v.1</div>
                    <div className="terms-container" style={{ marginTop: '1rem'}}>
                        <div className="terms-content">
                            <ol>
                                <li>
                                    <span>個人資料蒐集之主體</span>
                                    <span className='subcontent'>納智捷汽車股份有限公司(以下稱本公司)</span>
                                </li>
                                <li>
                                    <span>個人資料蒐集之目的</span>
                                    <span className='subcontent'>為您提供並優化納智捷APP和到府取送車服務(以下稱本服務)之業務功能的範圍內，本公司基於行銷（040）、非公務機關依法定義務所進行個人資料之蒐集處理及利用（063）、契約、類似契約或其他法律關係事務（069）、消費者、客戶管理與服務（090）、消費者保護（091）、商業與技術資訊（098）、會計與相關服務（129）、資（通）訊服務（135）、資（通）訊與資料庫管理（136）、資通安全與管理（137）、僱用與服務管理（145）、網路購物及其他電子商務服務（148）、輔助性與後勤支援管理（150）、廣告或商業行為管理（152）、徵信（154）、調查、統計與研究分析（157）、以及其他經營合於營業登記項目或組織章程所定之業務（181）、其他諮詢與顧問服務（182）等目的蒐集您的個人資料。</span>
                                </li>
                                <li>
                                    <span>個人資料蒐集之類別</span>
                                    <span className='subcontent'>為提供並執行本服務，本公司須向您蒐集以下個人資料：電子郵件、手機號碼、車輛照片、姓名、居住或工作地址、車輛所在位置、身分證字號、性別、年齡、信用卡、公司、職業、緊急聯絡人聯絡訊息，以及經您同意授權後，向第三方獲取的有關徵信資訊、行程資訊(包含服務出發地、到達地、行蹤軌跡、使用時間及里程數資訊)、客服資訊(包含客服專線之通話內容、通話時間、發話／受話手機號碼資訊、聯繫方式、和通過納智捷汽車APP發送的文字資訊內容等)、本服務預約單交易資訊(包含利用第三方支付功能使用本服務所產生之支付紀錄、信用卡、銀行帳號資訊)、其他系統上所儲存的日誌資訊(包含使用納智捷APP的檢索內容、IP位址、行動設備資訊（例如設備型號、設備識別碼、作業系統、解析度、電信運營商）)。</span>
                                </li>
                                <li>
                                    <span>個人資料處理和利用之期間、地區、對象及方式</span>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1.6rem'}}>(1)</div>
                                        <div style={{ flex: '1'}}>
                                            <span>您的個人資料將用於上述特定目的範圍與目的存續期間內，於中華民國境內及海外伺服器為必要之處理、利用。此外，必要時您的個人資料可能用於本公司為您所提供的海外產品或服務。在上述特定目的之存續期間、相關法令規定之應保存期間、因執行業務所必須之保存期間，或依個別契約就資料保存所定之保存年限內，本公司將持續保存您的個人資料。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1.6rem'}}>(2)</div>
                                        <div style={{ flex: '1'}}>
                                            <span>您的個人資料利用對象僅限本公司(含本公司經銷商)、裕隆汽車製造股份有限公司、裕融企業股份有限公司、裕富數位資融股份有限公司、新鑫股份有限公司、裕隆日產汽車股份有限公司及其經銷商、中華汽車工業股份有限公司及其經銷商、台灣英倫摩里斯汽車事業股份有限公司及其經銷商、華創車電技術中心股份有限公司、裕隆建設股份有限公司、祥碩興業股份有限公司、宏碩文化事業股份有限公司、行冠企業股份有限公司、行快科技股份有限公司、行將企業股份有限公司、嘉裕股份有限公司、台元紡織股份有限公司、新安東京海上產物保險股份有限公司、裕電能源股份有限公司、裕電俥電股份有限公司、格上汽車租賃股份有限公司、大濰科技股份有限公司、慶通汽車股份有限公司、觔斗雲聯網科技股份有限公司、以及本公司之子公司、海外分支機構、委外之協力廠商（例如：商品或服務之供應商以及提供各種資訊服務、數據分析服務、物流、金流或活動贈品、展示品之廠商）、對本公司有管轄權之中央或地方之目的事業主管機關、司法主管機關、依法有調查權之機關或其他政府機構，及其他本公司之交易相對人而有蒐集、處理、利用及國際傳輸個人相關資料必要者；您的個人資料如為本公司與其他廠商共同蒐集者，將於該共同蒐集之活動中另行載明蒐集主體，非經您的同意或其他法令之特別規定，或行政機關依法所提出之命令或要求，本公司不會將您的個人資料揭露予第三人或使用於蒐集目的以外之其他用途。</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <span>個人資料當事人權利行使</span>
                                    <span className='subcontent'>依據個人資料保護法第三條規定，就本公司保有您的個人資料，您得向本公司行使之權利包括：查詢、請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除；惟查詢、請求閱覽或請求製給複製本，本公司依法得酌收必要合理費用，而若蒐集、處理或利用個人資料係依法令執行業務所必須者，本公司得拒絕您停止蒐集、處理、利用或刪除之請求。您可透過本公司客服專線： 0800-588-088 行使以上權利，本公司將於收悉您的請求後，儘速回覆處理。</span>
                                </li>
                                <li>
                                    <span>未提供個人資料的權益影響</span>
                                    <span className='subcontent'>如您未能完整提供本公司所須蒐集的個人資料，本公司將可能婉謝、延遲或無法提供您本服務。</span>
                                </li>
                                <li>
                                    <span>其他隱私權保護相關事項</span>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1.6rem'}}>(1)</div>
                                        <div style={{ flex: '1'}}>
                                            <span>若您提供予本公司的個人資料並非您本人之個人資料，您應確定依法有權或已事前取得個人資料當事人同意由您代理將其個人資料提供予本公司，並已代本公司就本政策之內容告知個人資料當事人。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1.6rem'}}>(2)</div>
                                        <div style={{ flex: '1'}}>
                                            <span>當本公司之全部或部分有分割、獨立子公司經營、被其他第三者購併或收購資產，導致本公司或本公司數位服務平台（包括但不限於網站、軟體及APP應用程式等）之經營權轉換時，本公司會於事前將相關細節公告於本公司數位服務平台，且本公司所擁有之全部或部分使用者資訊亦可能在經營權轉換的狀況下移轉給第三人，惟限於與該經營權轉換服務相關之個人資料。若本公司或本公司數位服務平台之部分營運移轉予第三人後，如您不希望本公司繼續利用您的個人資料，您可以依本政策向本公司行使相關權利。</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex'}}>
                                        <div style={{ width: '1.6rem'}}>(3)</div>
                                        <div style={{ flex: '1'}}>
                                            <span>為了保護您的帳戶及個人資料的安全，請您不要任意將個人於本公司數位服務平台的帳號、密碼（如有）提供予第三人，或允許第三人以您的個人資料申請帳號、密碼，以避免您將自行承擔相關風險及責任的可能。若您的帳號、密碼有外洩之虞，請您立即更改密碼，或通知本公司暫停該帳號（屆時本公司將可能核對您的個人資料）。</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <span>隱私權政策修訂</span>
                                    <span className='subcontent'>本公司可能因應相關法令的修訂或其他環境變遷等因素，隨時對本政策內容進行適當的修正，修正後的條款將更新於本公司數位服務平台的適當位置，以告知您相關事項，不會另行各別通知您。若您不同意本政策的變更或修改，請停止繼續使用本公司產品及服務，並依本隱私權政策規定通知本公司停止蒐集、處理及利用您的個人資料。</span>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="button-container" >
                    <Button type="button" variant="success" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default Terms;